import { API } from "apis";
import React from "react";

export const useLimitPrice = () => {
  const [data, setData] = React.useState<any>();

  const load = async () => {
    try {
      const response = await API.Corp.limitPrice();
      const termData = response.data && Object.values(response.data).includes(null as any) ? null : response.data;
      setData(termData);
      return { data: termData };
    } catch (err) {
      console.log(err);
      return {};
    }
  };

  return { load, data };
};
